import React, { useEffect, useState } from "react";
import ModeratorCard from "./moderatorCard";
import PanelistCard from "./panelistCard";
import SpeakerCard from "./speakerCard";
import { useHistory, useLocation, useParams } from "react-router-dom";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import moment from "moment";
import Loader from "../UI Component/Loader/Loader";
import Call from "../../assets/call-24px.png";
import Email from "../../assets/mail.png";
import Checked from "../../assets/check-pink.svg";
import Calendar from "../../assets/calendar.svg";
import Clock from "../../assets/Clock.svg";
import GoBack from "../../assets/go_back.png";
import DownloadIcon from "../../assets/DownloadIconGrey.svg";
import C2CImg from "../../assets/C2CGrey.svg";
import FileIcon from "../../assets/Image 85.png";

import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const WebinarKnowMoreDetails = (props) => {
  let { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [webinar_details, setWebinarDetails] = useState({});
  const [agendaList, setAgendaList] = useState([]);
  const [moderatorList, setModeratorList] = useState([]);
  const [panelistList, setPanelistList] = useState([]);
  const [speakerList, setSpeakerList] = useState([]);
  const [testimonialList, setTestimonialList] = useState([]);
  const [pageLoader, setpageLoader] = useState(false);
  const [brochure, setBrochure] = useState({});

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    getWebinar();
    getAgenda();
    getSpeaker();
    getModerator();
    getTestimonial();
    getPanelist();
  }, []);

  const getWebinar = () => {
    setpageLoader(true);
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-webinar",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        webinar_id: id, //location.state.webinar_id,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          let start_date = response.data.start_date_time
            ? response.data.start_date_time.split("+")
            : "";
          let end_date = response.data.end_date_time
            ? response.data.end_date_time.split("+")
            : "";
          response.data["start_date_time"] = start_date[0];
          response.data["end_date_time"] = end_date[0];
          setWebinarDetails(response.data);
          if (response.data.webinar_documents.length > 0) {
            response.data.webinar_documents.map((doc, index) => {
              if (doc.document_type === "Brochure") {
                setBrochure(doc);
              }
            });
          }
        }
        setpageLoader(false);
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };

  const getAgenda = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/support/get-agenda",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        webinar_id: id, //location.state.webinar_id,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setAgendaList(response.data.agenda_data);
        } else {
          setAgendaList([]);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };

  const getTestimonial = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/support/get-testimonial",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        webinar_id: id, //location.state.webinar_id,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setTestimonialList(response.data.testimonial_data);
        } else {
          setTestimonialList([]);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };

  const getModerator = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/support/get-moderator",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        webinar_id: id, //location.state.webinar_id,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setModeratorList(response.data.moderator_data);
        } else {
          setModeratorList([]);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };
  const getPanelist = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/support/get-panelist",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        webinar_id: id, //location.state.webinar_id,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setPanelistList(response.data.panelist_data);
        } else {
          setPanelistList([]);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };
  const getSpeaker = () => {
    afterLoginApiAxios({
      method: "post",
      url: "/support/get-speaker",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: "1",
          user_id: userId,
        },
        webinar_id: id, //location.state.webinar_id,
      },
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setSpeakerList(response.data.speaker_data);
        } else {
          setSpeakerList([]);
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    summary: {
      // backgroundColor:"#f5f6f7 0% 0% no-repeat padding-box"
    },
  }));

  const classes = useStyles();

  return (
    <>
      {pageLoader ? (
        <div className="webinar_details_wrapper">
          <Loader />
        </div>
      ) : (
        <div className="webinar_details_wrapper">
          <div className="back_btn">
            <button
              type="button"
              class="btn btn-link apply"
              style={{ color: "#5AD5F2" }}
              onClick={() => history.goBack()} //push("/doctor/account/webinars")
            >
              <span className="mr-1 mb-1">
                {" "}
                <img src={GoBack} alt="" />
              </span>
              {"Go Back"}
            </button>
          </div>
          <div className="webinar_details_outer_container">
            <div className="webinar_details_container">
              <div className="row">
                <div className="col-12">
                  <p className="webinar_title">{webinar_details.title}</p>
                </div>
                <div className="col-12">
                  <span className="mr-1 mb-1">
                    {" "}
                    <img src={Calendar} alt="" width={16} height={16} />
                  </span>
                  <span className="date_time mr-3">
                    {/* {moment(webinar_details.webinar_start_date_time).format(
                      "MMM DD, YYYY"
                    )}{" "} */}
                    {moment(webinar_details.start_date_time).format(
                      "MMM DD,YYYY"
                    )}{" "}
                  </span>
                  <span className="mr-1 mb-1">
                    {" "}
                    <img src={Clock} alt="" width={16} height={16} />
                  </span>
                  <span className="date_time">
                    {moment(webinar_details.start_date_time).format("hh:mm a")}{" "}
                    {" - "}
                    {moment(webinar_details.end_date_time).format("hh:mm a")}
                  </span>
                </div>
              </div>

              <div className="row webinar_details mt-4">
                {webinar_details.description !== "" ? (
                  <div className="col-12">
                    <p className="label">Description</p>
                    <p className="webinar_description">
                      {webinar_details.description !== ""
                        ? webinar_details.description
                        : "-"}
                    </p>
                  </div>
                ) : null}

                {/* <div className="col-12 mt-4">
                  <p className="label">Specialisation</p>
                  <div className="d-flex flex-wrap">
                    {webinar_details.specialisation &&
                    webinar_details.specialisation.length > 0
                      ? webinar_details.specialisation.map((data) => (
                          <p className="specialisation mr-2 mb-2">
                            {data.display_name}
                          </p>
                        ))
                      : null}
                  </div>
                </div> */}

                {agendaList && agendaList.length > 0 ? (
                  <div className="col-12 mt-4">
                    <p className="label">Agenda</p>
                    <div className="d-flex flex-column">
                      {agendaList && agendaList.length > 0
                        ? agendaList.map((data) => (
                            <div className="d-flex my-2">
                              <img
                                src={Checked}
                                alt=""
                                width={16}
                                height={16}
                                className="mb-2"
                              />
                              <div className="d-flex flex-column ml-2">
                                <p className="agenda_data">
                                  {data.start_date_time
                                    ? moment(
                                        data.start_date_time.split("+")[0]
                                      ).format("hh:mm A")
                                    : "-"}{" "}
                                  -{" "}
                                  {data.end_date_time
                                    ? moment(
                                        data.end_date_time.split("+")[0]
                                      ).format("hh:mm A")
                                    : ""}
                                </p>
                                <p className="agenda_data">
                                  {data.description}
                                </p>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                ) : null}

                {moderatorList && moderatorList.length > 0 ? (
                  <div className="col-12 mt-4 desktop-view">
                    <p className="label">Moderator</p>
                    {moderatorList && moderatorList.length > 0 ? (
                      <>
                        <div className="d-flex overflow-auto">
                          {moderatorList.map((data, index) => (
                            <ModeratorCard moderator_data={data} />
                          ))}
                        </div>
                      </>
                    ) : (
                      <div>
                        <p>No moderator added</p>
                      </div>
                    )}
                  </div>
                ) : null}

                {panelistList && panelistList.length > 0 ? (
                  <div className="col-12 mt-4 desktop-view">
                    <p className="label">Panelists</p>
                    {panelistList && panelistList.length > 0 ? (
                      <>
                        <div className="d-flex overflow-auto">
                          {panelistList.map((data, index) => (
                            <PanelistCard panelist_data={data} />
                          ))}
                        </div>
                      </>
                    ) : (
                      <div>
                        <p>No panelist added</p>
                      </div>
                    )}
                  </div>
                ) : null}

                {speakerList && speakerList.length > 0 ? (
                  <div className="col-12 mt-4 desktop-view">
                    <p className="label">Speakers</p>
                    {speakerList && speakerList.length > 0 ? (
                      <>
                        <div className="d-flex overflow-auto">
                          {speakerList.map((data, index) => (
                            <SpeakerCard speaker_data={data} />
                          ))}
                        </div>
                      </>
                    ) : (
                      <div>
                        <p>No speaker added</p>
                      </div>
                    )}
                  </div>
                ) : null}

                <div className={`mobile-view ${classes.root}`}>
                  {moderatorList && moderatorList.length > 0 ? (
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={classes.summary}
                      >
                        <Typography className={classes.heading}>
                          Moderator
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {/* <Typography> */}
                        {moderatorList && moderatorList.length > 0 ? (
                          <>
                            <div className="d-flex overflow-auto w-100">
                              {moderatorList.map((data, index) => (
                                <ModeratorCard moderator_data={data} />
                              ))}
                            </div>
                          </>
                        ) : (
                          <div>
                            <p>No moderator added</p>
                          </div>
                        )}
                        {/* </Typography> */}
                      </AccordionDetails>
                    </Accordion>
                  ) : null}
                  {panelistList && panelistList.length > 0 ? (
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography className={classes.heading}>
                          Panelist
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {/* <Typography> */}
                        {panelistList && panelistList.length > 0 ? (
                          <>
                            <div className="d-flex overflow-auto w-100">
                              {panelistList.map((data, index) => (
                                <PanelistCard panelist_data={data} />
                              ))}
                            </div>
                          </>
                        ) : (
                          <div>
                            <p>No panelist added</p>
                          </div>
                        )}
                        {/* </Typography> */}
                      </AccordionDetails>
                    </Accordion>
                  ) : null}

                  {speakerList && speakerList.length > 0 ? (
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                      >
                        <Typography className={classes.heading}>
                          Speaker
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {/* <Typography> */}
                        {speakerList && speakerList.length > 0 ? (
                          <>
                            <div className="d-flex overflow-auto w-100">
                              {speakerList.map((data, index) => (
                                <SpeakerCard speaker_data={data} />
                              ))}
                            </div>
                          </>
                        ) : (
                          <div>
                            <p>No speaker added</p>
                          </div>
                        )}
                        {/* </Typography> */}
                      </AccordionDetails>
                    </Accordion>
                  ) : null}
                </div>

                <div className="col-12 mt-4">
                  <p className="label">Contact Us</p>
                  <div>
                    <p className="contact_us pb-2">
                      {" "}
                      <span className="mr-1">
                        {" "}
                        <img src={Email} alt="" width={16} height={16} />
                      </span>
                      {webinar_details.contact_email}
                    </p>
                  </div>
                  <div>
                    <p className="contact_us">
                      {" "}
                      <span className="mr-1">
                        <img src={Call} alt="" width={16} height={16} />
                      </span>
                      {webinar_details.contact_phone}
                    </p>
                  </div>
                </div>

                {Object.entries(brochure).length > 0 ? (
                  <div className="col-12 mt-4">
                    <p className="label">Webinar Brochure</p>
                    <div className="pdf-div">
                      <div className="pdf_img">
                        <img src={C2CImg} alt="" />
                      </div>
                      <div className="pdf-footer d-flex">
                        <img src={FileIcon} alt="" />
                        <a href={brochure.document_path[0]} download>
                          {brochure.document_title}
                        </a>
                        <img src={DownloadIcon} alt="" />
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WebinarKnowMoreDetails;
